import { createFileRoute } from "@tanstack/react-router";
import type { DashboardRange } from "@/api/types";
import { DashboardSkeleton } from "@/pages/dashboard/DashboardSkeleton";
import { SellerOverviewPage } from "@/pages/dashboard/SellerOverviewPage";

type DashboardSearch = { range?: DashboardRange };

// `range` belongs to the sales overview (DashboardPage), which reads mock data and returns with M7.
function validateSearch(search: Record<string, unknown>): DashboardSearch {
  const range = search.range === "7d" || search.range === "90d" || search.range === "30d"
    ? search.range
    : undefined;
  return { range };
}

export const Route = createFileRoute("/dashboard/")({
  validateSearch,
  pendingComponent: DashboardSkeleton,
  component: SellerOverviewPage,
});
